import {Consts} from "../pages/consts";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const InitFooter = ({parameter, onHandleBack, myPatient, onFinishInit, onHandleNext, nextButtonEnabled }) => {
  const { t: t } = useTranslation();

  return (
    <footer className="w3-container w3-center w3-padding-small">
      { parameter !== Consts.SUMMARY && (
        <div className="w3-left w3-padding-small">
          <button
            className={
              parameter === Consts.GENDER
                ? "hidden"
                : "w3-btn w3-round-xlarge w3-theme-d5"
            }
            onClick={onHandleBack}
          >
            {t(Consts.BACK)}
          </button>
        </div>
      )}
      { parameter === Consts.SUMMARY ? (
        <div className="w3-center w3-padding-small ">
          <Link
            to={"/drugsTab/"}
            className="w3-btn w3-round-xlarge w3-theme-d5"
            onClick={() => onFinishInit(myPatient)}
          >
            <label className="info-panel-text">
              {t(Consts.FINISH)}
            </label>
          </Link>
        </div>
      ) : (
        <div className="w3-right w3-padding-small">
          <button
            className="w3-btn w3-round-xlarge w3-theme-d5"
            onClick={onHandleNext}
            disabled={!nextButtonEnabled}
          >
            {t(Consts.NEXT)}
          </button>
        </div>
      )}
    </footer>
  )
}

export default InitFooter;